import { render, staticRenderFns } from "./getPanelsNumber.vue?vue&type=template&id=e71bcd8e&scoped=true"
import script from "./getPanelsNumber.vue?vue&type=script&lang=js"
export * from "./getPanelsNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71bcd8e",
  null
  
)

export default component.exports